import Filters from "@wwdev/product/filters";
import ResizingSelect from "../../base/ResizingSelect";
import SearchRequest from "@wwdev/product/SearchRequest";
import Slider from "../../externals/slider/Slider";

class CustomFilters extends Filters {
	constructor(config) {
		self.superConfig = Object.assign({
			filterToggle: '[data-filters="toggle"]',
			filterClose: '[data-filters="close"]',
			filterMenu: '[data-filters="menu"]',
			group: '[data-filters="group"]',
		}, config);

		super(self.superConfig);

		this.init();
	}

	init() {
		$(self.superConfig.filterToggle).on('click', (event) => this.toggleFiltersColumn(event));
		$(self.superConfig.filterClose).on('click', (event) => this.closeFiltersColumn(event));

		this.$keuzehulp = $('[data-scope="keuzehulp"]');
		if (this.$keuzehulp.length > 0) {
			this.$keuzehulp.on('click', '.keuzehulp-reset', this.resetFilter.bind(this))
				.on('click', '[data-pane]', (event) => this.openKeuzemenuStep(event))
				.on('click', '[data-offcanvas]', (event) => this.openKeuzehulp(event))
				.on('click', '[data-dismiss-keuzemenu]', (event) => this.closeKeuzehulp(event))
			;
		}

		this.initTabPane();
	}

	initEventListeners() {
		super.initEventListeners();

		$(this.config.filters).off('.collapse')
			.on('shown.bs.collapse', self.superConfig.group, this.afterGroupOpen.bind(this))
			.on('hidden.bs.collapse', self.superConfig.group, this.afterGroupClose.bind(this))
		;

		new ResizingSelect();
	}

	initTabPane() {
		$('.keuzehulp-tab-pane').each(function (iteration, element) {
			this.setStepNavigationState($(element));
		}.bind(this));
	}

	beforeCallback() {
		super.beforeCallback();
	}

	afterCallback() {
		super.afterCallback();

		$('#keuzehulp-start').addClass('d-none');
		$('#keuzehulp-producten').removeClass('d-none');
		new Slider();
	}

	setStepNavigationState($scope) {
		let $stepSelectedToProceed = $scope.find('.keuzehulp-card.active');
		if ($stepSelectedToProceed.length > 0) {
			$scope.find('.keuzehulp-proceed').removeClass('disabled');
		} else {
			$scope.find('.keuzehulp-proceed').addClass('disabled');
		}
	}

	resetFilter(e) {
		$('.keuzehulp-card').removeClass('active');
		super.resetFilter(e);
	}

	openKeuzehulp(event) {
		let offcanvas = $(event.currentTarget).data('offcanvas');
		this.getOffcanvas(offcanvas).show();
		this.scrollIntoView();
	}

	closeKeuzehulp(event) {
		let offcanvas = $(event.currentTarget).data('dismiss-keuzemenu');
		this.scrollIntoView();
		this.getOffcanvas(offcanvas).hide();
	}

	getOffcanvas(element) {
		return bootstrap.Offcanvas.getOrCreateInstance(element);
	}

	scrollIntoView() {
		this.headerMenuHeight = $('header.header-menu').outerHeight();
		window.scrollTo(0, this.$keuzehulp.offset().top - this.headerMenuHeight);
	}

	openKeuzemenuStep(event) {
		let targetPane = $(event.currentTarget).data('pane');
		const bsTab = new bootstrap.Tab(targetPane);
		let paneStep = $(targetPane).find('[data-step]').data('step');

		$('.keuzehulp #keuzehulp-content').find('.tab-pane').removeClass('active show');
		bsTab.show();

		let $keuzehulpFilters = $('#keuzehulp-filters');
		let stepProgress = (100 / $keuzehulpFilters.data('total-steps')) * paneStep;
		$keuzehulpFilters.scrollTop(0);
		$('.keuzehulp [data-scope="step-current"]').html(paneStep);
		$('.keuzehulp .progress-bar').css('width', stepProgress + '%');
	}

	handleResponse(response) {
		$(this.config.filters).html(response.filters);
		$(this.config.products).html(response.products);
		$(this.config.paginator).html(response.paginator);
		$(this.config.sort).html(response.sort);
		this.initEventListeners();
	}

	toggleFiltersColumn(event) {
		$(self.superConfig.filterToggle).toggleClass('open');
		$(this.config.filterMenu).toggleClass('filters-open');
		this.setFilterMenuCookie();
	}

	closeFiltersColumn(event) {
		$(self.superConfig.filterToggle).removeClass('open');
		$(this.config.filterMenu).removeClass('filters-open');
		this.setFilterMenuCookie();
	}

	setFilterMenuCookie() {
		this._setCookie(
			'filter-menu-open',
			$(this.config.filterMenu).hasClass('filters-open')
		);
	}

	afterGroupOpen(event) {
		let {tree, group, settings} = this.getData(event);
		if (!settings[tree]) {
			return;
		}
		delete settings[tree][group];
		this._setCookie('groups', settings);
	}

	afterGroupClose(event) {
		let {tree, group, settings} = this.getData(event);
		if (!settings[tree]) {
			settings[tree] = {}
		}
		settings[tree][group] = group;
		this._setCookie('groups', settings);
	}

	getData(event) {
		let $scope = $(event.currentTarget);
		let tree = $scope.data('tree');
		let group = $scope.data('group');
		let settings = this._getCookie('groups');
		return {tree, group, settings};
	}

	handleFilterClick(e) {
		this.filterTimeout ? clearTimeout(this.filterTimeout) : null;
		this.filterTimeout = setTimeout(() => {
			this.toggleKeuzeFilters(e);
			super.handleFilterClick(e);
		}, 1)
	}

	toggleKeuzeFilters(e) {
		let $target = $(e.currentTarget);
		let filterData = $target.data('filter');

		let identifier = $target.find('input').attr('id');
		let $optionCard = this.$keuzehulp.find(`.keuzehulp-card[data-identifier="${identifier}"]`);
		let $tabPane = $optionCard.closest('.keuzehulp-tab-pane');

		// Radio specific
		let radio = $target.find('input[type="radio"]');
		if (radio.length > 0) {
			if (SearchRequest.hasFilterGroup(filterData.tree_id)) {
				delete SearchRequest.request.filter[filterData.tree_id];
			}

			$tabPane.find('.keuzehulp-card').not($optionCard).removeClass('active');
		}

		// Handle state of visual check in keuzehulp
		if (SearchRequest.hasFilter(filterData.tree_id, filterData.id)) {
			$optionCard.removeClass('active');
		} else {
			$optionCard.addClass('active');
		}

		this.setStepNavigationState($tabPane);
	}

	_getCookie(key) {
		let cookie = $.cookie(key) ?? '{}';
		return JSON.parse(cookie);
	}

	_setCookie(key, cookie) {
		$.cookie(key, JSON.stringify(cookie), {path: '/'});
	}
}

export default new CustomFilters;
